//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChevronDownIcon from "./chevron-down-icon.vue";
import ChevronUpIcon from "./chevron-up-icon.vue";

export default {
    name: 'Detail',
    props: {
        row: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        is_new: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        display_transportation_type_filter: function () {
            return this.row.transportation_type_focused;
        },
        container_class: function () {
            // if index is even then we add class 'even'
            const suffix = this.index % 2 === 0 ? 'even' : 'odd';

            return `container py-4 ${suffix}`;
        },
        form_class: function () {
            if (this.is_row_open) {
                return 'collapse show';
            } else {
                return 'collapse';
            }
        },
    },
    methods: {
        shift_type: function (row) {
            const start_time = this.get_time_formatted(row.start_time);
            const end_time = this.get_time_formatted(row.end_time);

            return `From ${start_time} to ${end_time}`;
        },
        get_formatted_date(date) {
            const docfield = { fieldtype: "Date" };
            return frappe.format(date, docfield);
        },
        format_date(date) {
            return moment(date).format("MMMM Do YYYY");
        },
        toggle_open_row() {
            this.is_row_open = !this.is_row_open;
        },
        get_heading(row) {
            const formatted_date = this.format_date(row.date);

            let suffix = this.get_time_formatted(row.start_time);
            if (row.transportation_type !== "From Home to Work") {
                suffix = this.get_time_formatted(row.end_time);
            }

            return `${formatted_date} - ${suffix}`;
        },
        get_time_formatted(time) {
            if (!time) {
                return "...";
            }

            return moment(time, "HH:mm:ss").format("h:mm a");
        },
        opt_me_in_request: function (event) {
            event.preventDefault();
            frappe.call({
                method: "rcc_main.transportation.doctype.transportation_application.opt_me_in_request",
                args: {
                    application_id: this.row.name
                },
                callback: function ({ message }) {
                    if (message.message) {
                        frappe.show_alert(message.message);
                    }

                    if (message.comment) {
                        jQuery("#comment-list").append(message.comment);
                        frappe.ui.scroll("#comment-list", true);
                    }
                }
            });
        }
    },
    components: {
        ChevronUpIcon,
        ChevronDownIcon,
    },
    data() {
        return {
            is_row_open: false,
        };
    },
    mounted() {
        // if (!this.transportation_type) {
        //     this.row.transportation_type = "";
        // }
    }
}
